<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row">
                    <div class="col-12">
                        <div v-if="img !== null">
                            <AssetLoader :asset="{ asset: img.imageID }" />
                        </div>
                    </div>
                </div>
                <div class="row justify-content-lg-end">
                    <div
                        v-if="img.imgCredits"
                        class="col-12 col-lg-5 order-1 order-lg-2"
                    >
                        <div
                            class="credit-wrapper image-credit"
                            v-html="img.imgCredits"
                        ></div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'imgFullWidth',
    components: {
        AssetLoader
    },
    props: {
        img: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
